import 'slick-carousel';
import { commonSlickOptions, pickupSlickOptions } from '../scripts/front/slick_config.js';
import { calcSlideWidth, setLinkCardWidth } from '../scripts/front/slick_utils.js';

// トップページ用スライダー・タブ・サイドメニュー等の初期化処理集約ファイル
(function($){

  function sideMenu(){
      $('body').append('<div class="sideNavBg"></div>')
      // サイドメニュー開閉用イベントハンドラ追加
      $('#gheader .gnavBtn, #gsideMenu .menuBtn, .sideNavBg').on('click',function(){
          $('body').toggleClass('sideMenuOpen');
          return false;
      });
  }
  function initializeMainVisualSlides(){
      if($('.m_mvSlides').length){
          // メインビジュアルスライダー初期化処理
          $('.m_mvSlides .slides').slick({
              centerMode: true,
              // variableWidth: true,
              centerPadding: '0',
              autoplay: true,
              autoplaySpeed: 4000,
          });
      }
  }

  function tab(){
      // タブ切り替え処理
      $('.js_tab .tabMenu > li a').click(function(){
          var targetTab = $(this).attr('href');
          $('.js_tab .tabMenu > li a').removeClass('is_active');
          $(this).addClass('is_active');
          $(this).closest('.js_tab').find('.tab').hide();
          $(targetTab).fadeIn();
          return false;
      });
  }

  function initializeContentSlides(){
      let slideWidth;
      function applySlideWidth(){
          // スライド幅計算・設定処理
          slideWidth = calcSlideWidth();
          setLinkCardWidth('.js_mediaSlides', slideWidth);
      }
      applySlideWidth();
      // slickスライダー初期化
      $('.js_mediaSlides').slick(commonSlickOptions);

      function refreshSlideLayout(){
          // スライドレイアウト再計算・再描画処理
          applySlideWidth();
          $('.js_mediaSlides').find('.slick-slide').css('width', slideWidth + 'px');
          $('.js_mediaSlides').slick('setPosition');
      }

      $(window).on('load', function() {
        refreshSlideLayout();
      });

      var resizeTimer = null;
      $(window).on('resize', function() {
          // リサイズ時のスライド再描画（setTimeoutで連続実行抑制）
          refreshSlideLayout();
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(function() {
              refreshSlideLayout();
          }, 200);
      });

      // サイドメニュー開閉時のスライド再描画
      $('#gheader .gnavBtn, #gsideMenu .menuBtn, .sideNavBg').on('click',function(){
          $('#mainContents').on("transitionend", function() {
              refreshSlideLayout();
          });
      });
  }

  function initializePickupSlides(){
      // ピックアップスライダー初期化処理
      $('.js_pickupSlides .slides').slick(pickupSlickOptions);
      // サイドメニュー開閉時のスライド再描画
      $('#gheader .gnavBtn, #gsideMenu .menuBtn, .sideNavBg').on('click',function(){
          $('#mainContents').on("transitionend", function() {
              $('.js_pickupSlides .slides').slick('setPosition');
          });
      });
  }

  function truncatedText(){
      // 文字数制限によるテキスト省略処理
      $('.js_truncated').each(function() {
          var maxLength = $(this).data('maxlength');
          var text = $(this).text();
          if (text.length > maxLength) {
            var truncatedText = text.substring(0, maxLength) + '...';
            $(this).text(truncatedText);
          }
      });
  }

  $(function(){
      // DOM構築完了時の初期化処理
      sideMenu();
      initializeMainVisualSlides();
      tab();
      initializeContentSlides();
      initializePickupSlides();
      truncatedText();
  });

})(jQuery);
